import ModalScamAdvise from './ModalScamAdvise.jsx';

export default ModalScamAdvise;